import './loader.css'

const Spiner = () => {
  return (
    <div className="spinner-wrapper">
      <div className="spinner"></div>
      <p>Loading...</p>
    </div>
  );
};

export default Spiner;
